<template>
  <div class="footer tabbar row" style="z-index: 5">
    <a :class="['cc', {'active':vodActive }]" @click="toVod">
      <i class="iconfont icon-6b"></i>
      <span>视频</span>
    </a>
    
    <a :class="['cc', {'active': searchActive}]" @click="toVodSearch">
      <i class="iconfont icon-2b"></i>
      <span>搜视频</span>
    </a>

    <a :class="['cc', {'active': homeActive},'c-a']" @click="toHome">
      <i class="iconfont icon-6b"></i>
      <span>看漫画</span>
    </a>
    
   <!-- <a :class="['cc', {'active': newActive}]" @click="toNew">
     <i class="iconfont icon-5"></i>
     <span>更新</span>
    </a> -->
    <a :class="['cc', {'active': shelfActive}]" @click="toHistory">
      <i class="iconfont icon-3b"></i>
      <span>已购</span>
    </a>
    <a :class="['cc', {'active': userActive}]" @click="toMine">
      <i class="iconfont icon-4"></i>
      <span>我的</span>
    </a>
  </div>
</template>

<script>
  export default {
    name: "layer1",
    computed: {
      homeActive() {
        return this.$route.name === 'home'
      },
      searchActive() {
        return this.$route.path === '/search-vod'
      },
      vodActive() {
        return this.$route.path === '/vod'
      },
      newActive() {
        return this.$route.path === '/new'
      },
      shelfActive() {
        return this.$route.path === '/shelf-vod'
      },
      userActive() {
        return this.$route.path === '/user'
      }
    },
    methods: {
      toHome() {
        if (this.$route.name === 'home') return;
        this.$router.isBack = false;
        this.$router.push('/home')
        // this.$emit('page-change', 'home')
      },
      toVodSearch() {
        if (this.$route.name === 'search-vod') return;
        this.$router.isBack = false;
        this.$router.push('/search-vod')
        // this.$emit('page-change', 'search-vod')
      },
      toVod() {
        if (this.$route.name === 'vod') return;
        this.$router.isBack = false;
        this.$router.push('/vod')
        // this.$emit('page-change', 'vod')
      },
      toNew() {
        if (this.$route.name === 'new') return;
        this.$router.isBack = false;
        this.$router.push('/home/new')
      },
      toHistory() {
        if (this.$route.name === 'shelf-vod') return;
        this.$router.isBack = false;
        this.$router.push('/shelf-vod')
        // this.$emit('page-change', 'shelf-vod')
      },
      toMine() {
        if (this.$route.name === 'user') return;
        this.$router.isBack = false;
        this.$router.push('/user')
        // this.$emit('page-change', 'user')
      }
    }
  }
</script>

<style scoped>
  /*
  a.active {
    background-color: #f0f0f0;
  }
  a.active span {
    color: #000000;
  }
   */
   .tabbar a.router-link-active span, .tabbar a.active span{  color: #662281;font-weight: 600; }
   .footer{ background: #f6e3fa;}
   .tabbar a.router-link-active, .tabbar a.active { border-top: 2px solid #662281;}
   .tabbar a.c-a{ background: linear-gradient(to right,#d95f15,#9d50bb) !important;  border-radius: 0 0 20px 20px !important;
    margin-top: 0px !important;}
</style>



// WEBPACK FOOTER //
// src/components/layer1/bottomVod.vue